import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../../firebase';
import { handleFirebaseError } from '../../utils';
import { ROUTES, APP_NAME, APP_TAGLINE, COMPANY_EMAIL } from '../../constants';
import './Login.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      // Firebase Authentication ile giriş yap
      await signInWithEmailAndPassword(auth, email, password);

      // Firebase başarılı giriş yaptığında otomatik olarak oturum oluşturur
      navigate(ROUTES.DASHBOARD);
    } catch (error) {
      console.error('Giriş hatası:', error);
      setError(handleFirebaseError(error));
    } finally {
      setIsLoading(false);
    }
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    if (error) setError(''); // Email değiştiğinde hata mesajını temizle
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    if (error) setError(''); // Şifre değiştiğinde hata mesajını temizle
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>{APP_NAME}</h1>
          <p className="login-subtitle">Uçtan Uca {APP_TAGLINE}</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="email">
              <i className="fas fa-envelope"></i>
              Gmail Adresi
            </label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={handleEmailChange}
              placeholder={COMPANY_EMAIL}
              required
              disabled={isLoading}
              autoComplete="email"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">
              <i className="fas fa-lock"></i>
              Şifre
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={handlePasswordChange}
              placeholder="Şifrenizi girin"
              required
              disabled={isLoading}
              autoComplete="current-password"
            />
          </div>

          {error && (
            <div className="error-message">
              <i className="fas fa-exclamation-circle"></i>
              {error}
            </div>
          )}

          <button
            type="submit"
            className={`login-button ${isLoading ? 'loading' : ''}`}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <div className="spinner"></div>
                Giriş Yapılıyor...
              </>
            ) : (
              <>
                <i className="fas fa-sign-in-alt"></i>
                Giriş Yap
              </>
            )}
          </button>
        </form>

        <div className="login-footer">
          <div className="info-box">
            <i className="fas fa-info-circle"></i>
            <p>
              <strong>Giriş Bilgileri İçin</strong><br />
              Giriş bilgileri için {APP_NAME} yönetimi ile iletişime geçiniz.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login; 